.container {
  width: 400px;
  margin: 60px auto;
  font-family: Arial, sans-serif;
  text-align: center;
}
